module.exports = __webpack_public_path__ + "static/media/logo-white.34fdb0e9.svg";